var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('el-popover',{attrs:{"trigger":"hover"}},[_c('div',{staticStyle:{"min-width":"100px","max-width":"300px"}},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"text-truncate",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }